<template>
  <app-layout>
    <template #header>
      <div class="flex justify-between">
        <div>
          <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Centros de custo
          </h2>
        </div>
        <div class="float-right">
        </div>
      </div>
    </template>
    <div class="max-w-4xl mx-auto py-2 sm:px-2 lg:px-2 pb-8">
      <div class="md:grid">
        <div class="flex flex-col space-y-4 mt-2 sm:mt-4">
          <div
            v-for="centroCusto in centroCustos"
            :key="centroCusto.id"
            class="bg-white py-4 px-4 rounded mx-2 relative"
          >
            <div class="absolute top-0 right-2">
              <inertia-link :href="route('centro-custo.edit' , centroCusto.id)">
                <i class="cursor-pointer fas fa-pen text-xs"></i>
              </inertia-link>

            </div>
            <div class="text-sm leading-5 text-gray-900">{{centroCusto.id}} - {{centroCusto.nome}}</div>
            <div class="text-sm leading-5 text-gray-900">Filial : {{centroCusto.filial_id}} - {{centroCusto.filial.nome}}</div>
            <div>
              <div class="text-xs">Acompanhantes</div>
              <div class="divide-x"></div>
              <div class="text-xs ml-2">

                <div v-if="centroCusto.acompanhantes.length">
                  {{ joinAcompanhantes(centroCusto.acompanhantes)}}
                </div>
                <div v-else>
                  sem acompanhantes cadastrados
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import IconEdit from '@/Components/IconEdit';
import IconDelete from '@/Components/IconDelete';
import AlertError from '@/Components/AlertError';

export default {
  name: 'CentroCustoIndex',
  props: ['centroCustos'],
  components: {
    AppLayout,
    IconEdit,
    IconDelete,
    AlertError
  },
  methods: {
    joinAcompanhantes(acompanhantes) {
      return _.join(_.map(acompanhantes, 'name'), ',');
    }
  }
}
</script>


<style scoped>
</style>
